import React from 'react';
import {
  Paper,
  Typography,
  Box,
  IconButton,
  CircularProgress
} from '@mui/material';
import {
  RateReview as RateReviewIcon,
  Badge as EndorseIcon,
  Visibility as FollowIcon
} from '@mui/icons-material';

const BusinessInteractions = ({ 
  onWriteReview,
  onEndorse,
  onUnendorse,
  onFollow,
  onUnfollow,
  isTrustedThing,
  isFollowed,
  endorseButtonLoading,
  unendorseButtonLoading,
  followButtonLoading,
  unfollowButtonLoading,
  businessName
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, border: 'none' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Business Interactions</Typography>
      
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-around',
        mb: 1
      }}>
        {/* Write Review Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color="primary"
            onClick={onWriteReview}
            aria-label={`Write review for ${businessName}`}
          >
            <RateReviewIcon />
          </IconButton>
          <Typography variant="caption" align="center">
            Write Review
          </Typography>
        </Box>
        
        {/* Endorse/Unendorse Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color={isTrustedThing ? "secondary" : "default"}
            onClick={isTrustedThing ? onUnendorse : onEndorse}
            disabled={endorseButtonLoading || unendorseButtonLoading}
            aria-label={isTrustedThing ? `Unrefer ${businessName}` : `Refer ${businessName}`}
          >
            {(endorseButtonLoading || unendorseButtonLoading) ? 
              <CircularProgress size={20} color="inherit" /> : 
              <EndorseIcon />
            }
          </IconButton>
          <Typography variant="caption" align="center">
            {isTrustedThing ? "Unrefer" : "Refer"}
          </Typography>
        </Box>
        
        {/* Follow/Unfollow Button */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <IconButton 
            color={isFollowed ? "info" : "default"}
            onClick={isFollowed ? onUnfollow : onFollow}
            disabled={followButtonLoading || unfollowButtonLoading}
            aria-label={isFollowed ? `Unfollow ${businessName}` : `Follow ${businessName}`}
          >
            {(followButtonLoading || unfollowButtonLoading) ? 
              <CircularProgress size={20} color="inherit" /> : 
              <FollowIcon />
            }
          </IconButton>
          <Typography variant="caption" align="center">
            {isFollowed ? "Unfollow" : "Follow"}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default BusinessInteractions;